import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/videos/planet.mp4'


const _withScopeId = n => (_pushScopeId("data-v-a1388ec6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"head-title\" data-v-a1388ec6><h1 data-v-a1388ec6> Why am I doing it <br data-v-a1388ec6> What the results <br data-v-a1388ec6></h1><div class=\"head-title-options\" data-v-a1388ec6><ul class=\"slide-up-list\" data-v-a1388ec6><li class=\"slider-text\" data-v-a1388ec6>Will it be successful</li><li class=\"slider-text\" data-v-a1388ec6>THE ORCA DEV</li></ul></div><p class=\"head-title-subtitle\" data-v-a1388ec6> Before you start some develop, always ask yourself three questions </p></div>", 1)
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head-video" }, [
  /*#__PURE__*/_createElementVNode("video", {
    autoplay: "autoplay",
    muted: "muted",
    loop: "loop",
    class: "head-video",
    playsinline: ""
  }, [
    /*#__PURE__*/_createElementVNode("source", {
      src: _imports_0,
      type: "video/mp4"
    })
  ])
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const data = reactive({
  sliderOptions: ['our projects', 'contacts'],
  currentOption: 0
})
for (let i = 0; i < data.sliderOptions.length; i++) {
  setTimeout(() => {
    data.currentOption = i
  }, 2000 * i)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})